import {neverland as $, html, useState, useEffect} from 'neverland';

import buildForm from '../../../admin/js/tripetto-constructors/buildForm.js';
import { run } from "@tripetto/runner-autoscroll";
import { Export } from "@tripetto/runner";
import database from '../lib/database.js';


function isInteger(value) {
	return /^\d+$/.test(value);
}

function fixType(value) {
	if (value == "true") {
		return true;
	} else if (value == "false") {
		return false;
	} else if (isInteger(value)) {
		return Number(value);
	} else {
		return value;
	}
}

function groupByNode(slots) {

	slots = slots.map(slot => {
		slot.nodeId = slot.node.props().id.split('-').slice(0,2).join('-');
		return slot;
	});

	// Get unique node IDs.
	let nodeIds = slots.map(d => d.nodeId).filter((item, i, ar) => ar.indexOf(item) === i);

	let nodes = [];

	for (let id of nodeIds) {
		let matchingSlots = slots.filter(slot => slot.nodeId == id);
		nodes.push({
			id: id,
			slots: matchingSlots,
			type: matchingSlots[0].type
		})
	}

	return nodes;
}

function getRandomSubarray(arr, size) {

    var shuffled = arr.slice(0), i = arr.length, temp, index;

    while (i--) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
    }

    return shuffled.slice(0, Math.min(size, shuffled.length));
}

const Survey = $(function(auth, page, setPage, a11y, setA11y) {
	const [tripettoReady, setTripettoReady] = useState(false);
	const [visible, setVisible] = useState(false);
	const [a11yOpen, setA11yOpen] = useState(false);

	function toggleA11y(key) {
		setA11y(prev => ({ ...prev, [key]: !prev[key] }));
	}

	function slideA11y(key) {
		return (e) => setA11y(prev => ({ ...prev, [key]: Number(e.target.value) }));
	}

	function applyA11yToIframe(settings = a11y) {
		const iframe = document.querySelector('.survey iframe');
		if (!iframe || !iframe.contentDocument) return;
		const iframeHtml = iframe.contentDocument.documentElement;
		iframeHtml.classList.toggle('a11y-no-bg', settings.noBg);
		iframeHtml.classList.toggle('a11y-reduced-motion', settings.reducedMotion);
		iframeHtml.style.setProperty('--a11y-contrast', `${settings.highContrast}%`);

		const defaultSize = window.innerWidth <= 600 ? 12 : 16;
		let styleEl = iframe.contentDocument.getElementById('a11y-font-style');
		if (!styleEl) {
			styleEl = iframe.contentDocument.createElement('style');
			styleEl.id = 'a11y-font-style';
			iframe.contentDocument.head.appendChild(styleEl);
		}
		if (settings.largeText != defaultSize) {
			const scale = settings.largeText / defaultSize;
			styleEl.textContent = `*:not(body > nav):not(body > nav *):not(.top-controls):not(.top-controls *) { font-size: ${settings.largeText}px !important; } select, option, input, textarea, button, label, li, ul, h1, h2, h3, h4, h5, h6, span { font-size: ${settings.largeText}px !important; } h2 label span, h3 span { font-size: 1rem !important; } img { max-width: 100%; width: calc(100% * ${scale}); height: auto; }`;
		} else {
			styleEl.textContent = '';
		}
	}

	useEffect(() => { applyA11yToIframe(a11y); }, [a11y]);

	// Initialise Tripetto.
	useEffect(() => {
		console.log("Loading survey...")

		// Keep track of any new Items or ItemSets so that we can set hasResponses = true on submission.
		let newItems = page.survey.Items.filter(d => {
				if (d.hasOwnProperty('hasResponses')) {
					return !d.hasResponses;
				} else {
					return true;
				}
			}).map(d => d._id),
			newItemSets = page.survey.ItemSets.filter(d => {
				if (d.hasOwnProperty('hasResponses')) {
					return !d.hasResponses;
				} else {
					return true;
				}
			}).map(d => d._id);



		let extraItems = [];
		
		// Append rotator items.
		
		let rotatorItems = [];
		if (page.survey.ItemSet.rotators) {
			
			let rotators = page.survey.ItemSet.rotators;
			
			if (page.survey.ItemSet.rotators.length > 1) {
				for (let rotator of rotators) {

					let itemPool = page.survey.RotatorItemSets.filter(d => d.id == rotator.element)[0].elements.map(d => d.element);

					// Append rotator items.
					let thisRotatorItems = getRandomSubarray(itemPool, Number(rotator.n));
					rotatorItems = rotatorItems.concat(thisRotatorItems);
					for (let item of thisRotatorItems) {
						extraItems.push({
							collection: 'Items',
							element: item,
							required: true,
							conditions: [],
							conditionAggregator: ""
						})
					}
				}
			}
		}

		// Append test retest item(s).

		function flattenElements(elements, itemSets, parentConditions = [], parentAggregator = "") {
			let flat = [];
			for (let el of elements) {
				if (el.collection === 'Items') {
					flat.push({
						...el,
						conditions: [...parentConditions, ...(el.conditions || [])],
						conditionAggregator: el.conditionAggregator || parentAggregator
					});
				} else if (el.collection === 'ItemSets') {
					let nested = itemSets.find(d => d.id === el.element);
					if (nested && Array.isArray(nested.elements)) flat = flat.concat(flattenElements(nested.elements, itemSets, [...parentConditions, ...(el.conditions || [])], el.conditionAggregator || parentAggregator));
				}
			}
			return flat;
		}

		let testRetestItems = [];
		if (page.survey.Survey.includeTestRetest) {

			let itemPool = page.survey.Items.filter(d => d.testRetestEligibility).map(d => d.id);

			if (itemPool.length > 0) {
				let testRetestItem = getRandomSubarray(itemPool, 1)[0];
				testRetestItems.push(testRetestItem);

				let flatElements = flattenElements(page.survey.ItemSet.elements, page.survey.ItemSets);
				let testRetestEl = flatElements.find(el => el.element === testRetestItem) || { conditions: [], conditionAggregator: "" };

				// Fetch explanation item and add to Items so buildForm can find it.
				if (page.survey.TestRetestExplanationItem && !page.survey.Items.find(d => d.id === '61cdf469f43e617559227ea1')) {
					page.survey.Items.push(page.survey.TestRetestExplanationItem);
				}

				// Append test-retest explanation.
				extraItems.push({
					collection: 'Items',
					element: "61cdf469f43e617559227ea1",
					required: true,
					conditions: testRetestEl.conditions,
					conditionAggregator: testRetestEl.conditionAggregator
				});

				// Append test-retest item.
				extraItems.push({
					collection: 'Items',
					element: testRetestItem,
					required: true,
					conditions: testRetestEl.conditions,
					conditionAggregator: testRetestEl.conditionAggregator
				});

			}
		}

		page.survey.ItemSet.elements = page.survey.ItemSet.elements.concat(extraItems);

		// Append RotatorItems to Items so that they are accessible by buildForm.
		page.survey.Items = page.survey.Items.concat(page.survey.RotatorItems);

		// Build form.
		let surveyName = page.survey.Survey.hasOwnProperty("name") ? page.survey.Survey.name.toLowerCase() : '';
		let form = buildForm(page.survey);

		run({
			element: document.querySelector('.survey'),
			definition: form,
			styles: {
				direction: "vertical",
				verticalAlignment: "middle",
				hidePast: true,
				hideUpcoming: true,
				showNavigation: "always",
				showProgressbar: true,
				showEnumerators: true,
				autoFocus: true,
				showSeparateSubmit: true,
				showPreviousButton: true,
				showScrollbar: false,
				disableScrolling: false,
				noBranding: true,
				hideRequiredIndicator: true,
				contract: {
					name: "@tripetto/runner-autoscroll",
					version: "9.0.1"
				}
			},
			customCSS: `{ visibility: hidden; } > nav { background-color: #ffffff44 !important; }`,
			onReady: () => {
				setTripettoReady(true);
			},
			onSubmit: async function(instance) {

				let fields = Export.fields(instance).fields
					.filter(f => ![undefined, '', null, NaN].includes(f.value));

				let nodes = groupByNode(fields);

				nodes = nodes.map(node => {
					switch (node.type) {
						
						case '@tripetto/block-dropdown':
							return {
								item: node.id.split('-')[0],
								answer: fixType(node.slots[0].value)
							};
							break;
						
						case '@tripetto/block-multiple-choice':
						
							// if (d.slots[0].node.props().block.multiple) { // <-- Might be more robust
							if (node.slots.length > 1) {
								return {
									item: node.id.split('-')[0],
									answer: node.slots.filter(slot => slot.value).map(slot => fixType(slot.slot.split('-')[3]))
								}
							} else {
								return {
									item: node.id.split('-')[0],
									answer: fixType(node.slots[0].value)
								}
							}
							break;
						
						case '@tripetto/block-text':
						case '@tripetto/block-textarea':
							
							return {
								item: node.id.split('-')[0],
								answer: node.slots[0].value
							}
							break;

						case '@tripetto/block-number':
							
							return {
								item: node.id.split('-')[0],
								answer: node.slots[0].value
							};
							break;
						
						default:
							return {};
							break;
					}
				})				

				// console.log(nodes);

				if (page.hasOwnProperty('accessCode')) {
					nodes = [{
						item: '611718091d9f529a4f4f0d22',
						answer: page.accessCode
					}].concat(nodes);
				}
				
				let response = {
					survey: page.survey.Survey._id["$oid"],
					itemSet: page.survey.ItemSet.id,
					timestamp: (new Date()).toString(),
					answers: nodes,
					rotatorItems: rotatorItems,
					testRetestItems: testRetestItems
				}

				let submitted = await auth.db.collection('Responses').insertOne(response);

				// Update items and itemsets to mark as having responses
				for (let itemId of newItems) {
					await auth.db.collection('Items').updateOne(
						{ _id: itemId },
						{ $set: { hasResponses: true } }
					);
				}
				for (let itemSetId of newItemSets) {
					await auth.db.collection('ItemSets').updateOne(
						{ _id: itemSetId },
						{ $set: { hasResponses: true } }
					);
				}

				// Redirect to end screen
				setPage(prevPage => {
					let page = {...prevPage};
					page.id = 'EndScreen';
					return page;
				});
			}
		});


	}, [])

	function injectAriaAnnouncer(iframe) {
		const doc = iframe.contentDocument;
		if (!doc || doc.getElementById('ry-announcer')) return;
		const announcer = doc.createElement('div');
		announcer.id = 'ry-announcer';
		announcer.setAttribute('aria-live', 'polite');
		announcer.setAttribute('aria-atomic', 'true');
		announcer.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
		doc.body.appendChild(announcer);
		let lastText = '';
		const observer = new MutationObserver(() => {
			const questionEl = doc.querySelector('h1, h2, h3, h4, h5, h6');
			const text = questionEl ? questionEl.textContent.trim() : '';
			if (text && text !== lastText) {
				lastText = text;
				announcer.textContent = '';
				setTimeout(() => { announcer.textContent = text; }, 300);
			}
		});
		observer.observe(doc.body, { childList: true, subtree: true, characterData: false, attributes: false });
	}

	// // Add custom CSS.
	useEffect(() => {
		if(!tripettoReady) return;

		let loadedBaseCSS = false,
			loadedCSSparams = false;

		function loadCSS(iframe) {

			let sheets = document.styleSheets,
				existingLinks = iframe.contentDocument.querySelectorAll("link");

			if (existingLinks.length == 0) {
				// Re-add stylesheets.
				for (let sheet of sheets) {
					
					let { href, title, ownerNode } = sheet;

					if (href !== null & title == "tripetto" & !loadedBaseCSS) {
						// Inject base CSS.

						const link = iframe.contentDocument.createElement("link");
						link.href = href;
						link.rel = "stylesheet";
						iframe.contentDocument.body.appendChild(link);
						loadedBaseCSS = true;
					}

					if (ownerNode.id == 'css-parameters' & !loadedCSSparams) {
						// Inject CSS parameters.

						const style = iframe.contentDocument.createElement("style");
						style.innerHTML = sheet.rules[0].cssText;
						iframe.contentDocument.body.appendChild(style);
						loadedCSSparams = true;
					}
				}
			}
			setVisible(true);
		}

		let iframe = document.querySelector('.survey iframe');
		if(iframe){			
			iframe.addEventListener("load", () => {	
			loadCSS(iframe);
				injectAriaAnnouncer(iframe);
				applyA11yToIframe(a11y);
			});
			setTimeout(() => {
			if (!loadedBaseCSS & !loadedCSSparams) {
				loadCSS(iframe);
				injectAriaAnnouncer(iframe);
				applyA11yToIframe(a11y);
				}			
			}, 100);
		}
	}, [tripettoReady]);

	return html`
		<div class="survey${visible ? '' : ' hide'}"></div>
		<div class="top-controls">
			<div class="a11y-widget">
				${a11yOpen ? html`<div class="curtain" onclick="${() => setA11yOpen(false)}"></div>` : ''}
				<button class="a11y-toggle" onclick="${() => setA11yOpen(o => !o)}" aria-expanded="${a11yOpen}" aria-label="Accessibility options" data-tooltip="Accessibility options"><i class="fas fa-universal-access" aria-hidden="true"></i></button>
				${a11yOpen ? html`
					<div class="a11y-panel" role="dialog" aria-label="Accessibility options">
						<label class="a11y-slider-label">Contrast<input type="range" min="50" max="200" value="${a11y.highContrast}" oninput="${slideA11y('highContrast')}" aria-label="Contrast" /></label>
						<label class="a11y-slider-label">Text size<input type="range" min="10" max="28" value="${a11y.largeText}" oninput="${slideA11y('largeText')}" aria-label="Text size" /></label>
						<label><input type="checkbox" checked="${a11y.reducedMotion}" onchange="${() => toggleA11y('reducedMotion')}" /> Reduce motion</label>
						<label><input type="checkbox" checked="${a11y.noBg}" onchange="${() => toggleA11y('noBg')}" /> Remove background image</label>
					</div>
				` : ''}
			</div>
		</div>
	`;

});

export default Survey;
